import script from "./EIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./EIcon.vue?vue&type=script&lang=ts&setup=true"

import "./EIcon.vue?vue&type=style&index=0&id=e7bd48ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7bd48ea"]])

export default __exports__